<template>
  <div style="height: 100%;">
    <div class="spin">
      <div
        style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"
      >
        <div>
          <img
            src="../assets/images/logo2.png"
            loading="lazy"
            style="height:100px;"
          />
        </div>
        <div
          style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;"
        >
          <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
        </div>
      </div>
      <div
        style="position: absolute; top: 60px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
      >
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptionsCut"
            :options="defaultOptionsCut"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimationCut"
          />
        </div>
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptionsPaper"
            :options="defaultOptionsPaper"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimationPaper"
          />
        </div>
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptionsHammer"
            :options="defaultOptionsHammer"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimationHammer"
          />
        </div>
      </div>
      <div
        style="position: absolute; top: 300px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
      >
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptions2Cut"
            :options="defaultOptions2Cut"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimation2Cut"
          />
        </div>
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptions2Paper"
            :options="defaultOptions2Paper"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimation2Paper"
          />
        </div>
        <div
          style="position: absolute; top: 0px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
        >
          <lottie
            v-if="defaultOptions2Hammer"
            :options="defaultOptions2Hammer"
            :height="250"
            :width="250"
            v-on:animCreated="handleAnimation2Hammer"
          />
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          top: '200px',
          'align-items': 'center',
          'justify-content': 'center',
          display: 'flex',
          left: '0',
          right: '0',
          display: showResult ? 'block' : 'none'
        }"
      >
        <div
          :style="{
            position: 'absolute',
            top: '0px',
            'align-items': 'center',
            'justify-content': 'center',
            display: win,
            left: '0',
            right: '0'
          }"
        >
          <!-- <lottie :options="defaultOptionsWin" :height="550" :width="550"  v-on:animCreated="handleAnimationWin" /> -->
          <img src="../assets/images/win.png" />
        </div>
        <div
          :style="{
            position: 'absolute',
            top: '0px',
            'align-items': 'center',
            'justify-content': 'center',
            display: lose,
            left: '0',
            right: '0'
          }"
        >
          <!-- <lottie :options="defaultOptionsLose" :height="550" :width="550"  v-on:animCreated="handleAnimationLose" /> -->
          <img src="../assets/images/lose.png" />
        </div>
        <div
          :style="{
            position: 'absolute',
            top: '0px',
            'align-items': 'center',
            'justify-content': 'center',
            display: draw,
            left: '0',
            right: '0'
          }"
        >
          <!-- <lottie :options="defaultOptionsDraw" :height="550" :width="550"  v-on:animCreated="handleAnimationDraw" /> -->
          <img src="../assets/images/draw.png" />
        </div>
      </div>
      <div
        style="position: absolute; bottom: 80px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
      >
        <div
          style="display: flex; flex: 1; align-items: center; justify-content: center;"
        >
          <div style="border-style: dashed;">
            <img
              src="../assets/images/1cut.png"
              width="124"
              @click="select('cut')"
            />
          </div>
          <div style="border-style: dashed;">
            <img
              src="../assets/images/2paper.png"
              width="124"
              @click="select('paper')"
            />
          </div>
          <div style="border-style: dashed;">
            <img
              src="../assets/images/3hammer.png"
              width="124"
              @click="select('hammer')"
            />
          </div>
        </div>
      </div>
      <div
        style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;"
      >
        <div
          style="display: flex; flex: 1; align-items: center; justify-content: center;"
        >
          <div
            style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;"
          >
            <span class="glow" ref="myBtn">
              {{ loadingtext }}
            </span>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
import router from "./../router";
import Lottie from "./lottie.vue";
import { loadAnimation } from "@/services/lottieLoader";
import liffService from "@/services/liff";
export default {
  name: "S1",
  async created() {
    const [animage, animage2, animage3] = await Promise.all([
      loadAnimation('1cut'),
      loadAnimation('2paper'),
      loadAnimation('3hammer')
    ]);
    this.defaultOptionsCut = {
      animationData: animage,
      autoplay: false,
      loop: false
    };
    this.defaultOptions2Cut = {
      animationData: animage,
      autoplay: false,
      loop: false
    };
    this.defaultOptionsPaper = {
      animationData: animage2,
      autoplay: false,
      loop: false
    };
    this.defaultOptions2Paper = {
      animationData: animage2,
      autoplay: false,
      loop: false
    };
    this.defaultOptionsHammer = {
      animationData: animage3,
      autoplay: false,
      loop: false
    };
    this.defaultOptions2Hammer = {
      animationData: animage3,
      autoplay: false,
      loop: false
    };
  },
  components: {
    lottie: Lottie
  },
  data() {
    return {
      win: "none",
      lose: "none",
      draw: "none",
      showResult: false,
      pictureUrl: "",
      mycoin: 0,
      showLoading: true,
      isDisabled: true,
      percentage: 0,
      canOpen: false,
      loadingtext: "น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่",
      defaultOptionsCut: null,
      defaultOptionsPaper: null,
      defaultOptionsHammer: null,
      defaultOptions2Cut: null,
      defaultOptions2Paper: null,
      defaultOptions2Hammer: null,
      animCut: null,
      animPaper: null,
      animHammer: null,
      animCut2: null,
      animPaper2: null,
      animHammer2: null,
      userId: "",
      userKey: "",
      displayName: "",
      statusMessage: "",
    };
  },
  mounted() {
    //   this.anim.play();
    // LIFF is already initialized by router guard
    this.loadUserData();
    //   setTimeout(() => {
    //     this.showLoading = false;
    //     this.anim.stop()
    //     setTimeout(() => {
    //       this.animempty1.hide()
    //       this.animempty2.hide()
    //       this.animempty3.hide()
    //       this.animpoint1.hide()
    //       this.animpoint2.hide()
    //       this.animpoint3.hide()
    //       this.anim1.play()
    //       this.anim2.play()
    //       this.anim3.play()
    //     }, 500)
    //   }, 2500);
  },
  methods: {
    select(select) {
      if (this.canOpen) {
        this.$confirm({
          message: `ยืนยันการเลือก${
            select === "cut" ? "กรรไกร" : select === "paper" ? "กระดาษ" : "ค้อน"
          }?`,
          button: {
            yes: "OK",
            no: "Cancel"
          },
          callback: async confirm => {
            if (confirm) {
              this.canOpen = false;
              const com = Math.floor(Math.random() * 3);
              let select2 = "";
              if (com === 0) {
                select2 = "cut";
                this.animPaper.hide();
                this.animHammer.hide();
                this.animCut.play();
              } else if (com === 1) {
                select2 = "paper";
                this.animPaper.play();
                this.animHammer.hide();
                this.animCut.hide();
              } else {
                select2 = "hammer";
                this.animPaper.hide();
                this.animHammer.play();
                this.animCut.hide();
              }

              if (select === "cut") {
                this.animCut2.play();
                this.animPaper2.hide();
                this.animHammer2.hide();
              } else if (select === "paper") {
                this.animPaper2.play();
                this.animCut2.hide();
                this.animHammer2.hide();
              } else {
                this.animHammer2.play();
                this.animCut2.hide();
                this.animPaper2.hide();
              }
              console.log(select2 + "==" + select);
              if (select2 === select) {
                console.log("draw");
                setTimeout(() => {
                  this.showResult = true;
                  this.win = "none";
                  this.lose = "none";
                  this.draw = "flex";
                  firebase
                    .firestore()
                    .collection("scratch")
                    .doc(
                      this.userId +
                        "-" +
                        moment()
                          .tz("Asia/Bangkok")
                          .format("YYYY-MM-DD")
                    )
                    .set({
                      userId: this.userId,
                      createdate: moment()
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD HH:mm:ss"),
                      spin: 0,
                      value: 0
                    });
                  setTimeout(() => {
                    this.sendMessageLine(`คุณเสมอเสียใจด้วยนะจ๊ะ 😢`);
                  }, 2000);
                  // this.animDraw.play()
                  // this.animWin.hide()
                  // this.animLose.hide()
                }, 3000);
              } else if (
                (select2 === "cut" && select === "paper") ||
                (select2 === "paper" && select === "hammer") ||
                (select2 === "hammer" && select === "cut")
              ) {
                console.log("lose");
                setTimeout(() => {
                  this.showResult = true;
                  this.win = "none";
                  this.lose = "flex";
                  this.draw = "none";
                  firebase
                    .firestore()
                    .collection("scratch")
                    .doc(
                      this.userId +
                        "-" +
                        moment()
                          .tz("Asia/Bangkok")
                          .format("YYYY-MM-DD")
                    )
                    .set({
                      userId: this.userId,
                      createdate: moment()
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD HH:mm:ss"),
                      spin: 0,
                      value: 0
                    });
                  setTimeout(() => {
                    this.sendMessageLine(`คุณแพ้เสียใจด้วยนะจ๊ะ 😭`);
                  }, 2000);
                  // this.animLose.play()
                  // this.animWin.hide()
                  // this.animDraw.hide()
                }, 3000);
              } else {
                const item = 50;
                setTimeout(() => {
                  this.showResult = true;
                  this.win = "flex";
                  this.lose = "none";
                  this.draw = "none";
                  // this.animWin.play()
                  // this.animDraw.hide()
                  // this.animLose.hide()
                  firebase
                    .firestore()
                    .collection("scratch")
                    .doc(
                      this.userId +
                        "-" +
                        moment()
                          .tz("Asia/Bangkok")
                          .format("YYYY-MM-DD")
                    )
                    .set({
                      userId: this.userId,
                      createdate: moment()
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD HH:mm:ss"),
                      spin: Number(item),
                      value: Number(item)
                    });
                  setTimeout(() => {
                    this.$confirm({
                      message: `✌️ ปังปุรีเย่!! คุณได้รับ ${item} เหรียญ😘😘`,
                      button: {
                        yes: "OK"
                      },
                      callback: async confirm => {
                        if (confirm) {
                          this.sendMessageLine3(item + " เหรียญ");
                        }
                      }
                    });
                  }, 2000);
                }, 3000);
              }
            }
          }
        });
      }
    },
    handleAnimationCut: function(anim) {
      this.animCut = anim;
    },
    handleAnimationPaper: function(anim) {
      this.animPaper = anim;
    },
    handleAnimationHammer: function(anim) {
      this.animHammer = anim;
    },
    handleAnimation2Cut: function(anim) {
      this.animCut2 = anim;
    },
    handleAnimation2Paper: function(anim) {
      this.animPaper2 = anim;
    },
    handleAnimation2Hammer: function(anim) {
      this.animHammer2 = anim;
    },
    // handleAnimationWin: function (anim) {
    //   this.animWin = anim
    // },
    // handleAnimationLose: function (anim) {
    //   this.animLose = anim
    // },
    // handleAnimationDraw: function (anim) {
    //   this.animDraw = anim
    // },
    async sendMessageLine(text) {
      await window.liff.sendMessages([
        {
          type: "text",
          text: "✌️ " + text
        }
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text) {
      await window.liff.sendMessages([
        {
          type: "text",
          text: "✌️ " + text
        }
      ]);
    },
    async sendMessageLine3(text) {
      await window.liff.sendMessages([
        {
          type: "flex",
          altText: "ปังปุรีเย่!! คุณได้รับ " + text,
          contents: {
            type: "bubble",
            size: "micro",
            body: {
              type: "box",
              layout: "vertical",
              contents: [
                {
                  type: "text",
                  text: "ยินดีด้วยค่ะ !",
                  color: "#CCCCCC",
                  size: "lg",
                  weight: "bold",
                  align: "center"
                },
                {
                  type: "image",
                  url:
                    "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                  position: "relative",
                  size: "sm"
                },
                {
                  type: "text",
                  text: "+" + text,
                  size: "sm",
                  color: "#CCCCCC",
                  align: "center",
                  weight: "bold"
                }
              ],
              spacing: "xxl",
              margin: "none",
              action: {
                type: "uri",
                label: "action",
                uri: "https://liff.line.me/2006378234-72e9GVNa/reward",
                altUri: {
                  desktop: "https://liff.line.me/2006378234-72e9GVNa/reward"
                }
              },
              background: {
                type: "linearGradient",
                angle: "0deg",
                startColor: "#DD2476",
                endColor: "#FF512F"
              }
            },
            styles: {
              footer: {
                separator: true
              }
            }
          }
        }
      ]);
      window.liff.closeWindow();
    },
    async loadUserData() {
      if (!window.liff.isInClient()) {
        router.replace("/login");
      } else {
        // Get profile from centralized service (already fetched by router guard)
        const profile = liffService.profile;
        if (!profile) return;

        this.userId = profile.userId || "";
        this.pictureUrl = profile.pictureUrl || "none";
        this.displayName = profile.displayName ? profile.displayName : "none";
        this.statusMessage = profile.statusMessage
          ? profile.statusMessage
          : "none";
        if (this.userId) {
          const user = (
            await firebase
              .database()
              .ref(`/users`)
              .orderByChild("userId")
              .equalTo(this.userId)
              .once("value")
          ).val();
          if (user) {
            const u = user[Object.keys(user)[0]];
            this.mycoin = u.coins ? u.coins : 0;
            this.userKey = Object.keys(user)[0];
            this.sendMessageLine2(
              "สนใจเล่นเป่ายิ้งฉุบ พลอยใสจัดการให้หน่อย 😘😘"
            );
            if (moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === "2026-03-30") {
              await firebase
                .firestore()
                .collection("scratch")
                .doc(this.userId +"-" +moment().tz("Asia/Bangkok").format("YYYY-MM-DD"))
                .get()
                .then(async snapshot => {
                  if (snapshot.exists) {
                    this.sendMessageLine(
                      "ลูกค้าเล่นเป่ายิ้งฉุบไปแล้วนะคะวันนี้ รอวันใหม่นะคะ 😘😘"
                    );
                  } else {
                    await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                      let credit = 0;
                      snapshot.forEach((doc)=>{
                        credit += Number(doc.data().qty);
                      });
                      if(credit >= 500){
                        this.loadingtext = 'น้องออโต้พร้อมแล้วเล่นเป่ายิ้งฉุบ ได้เลยค่ะ😘😘';
                        this.showLoading = true;
                        this.canOpen= true;
                      }else{
                        const less = 500-Number(credit);
                        this.loadingtext = `เติมเงินอีก ${less}(500) ได้เล่นเลยค่ะ!😘😘`;
                      }
                    });
                  }
                });
            } else {
              this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 30 March เท่านั้น!😘😘`;
            }
          } else {
            router.replace("/register");
          }
        }
        this.isDisabled = false;
      }
    }
  }
};
</script>

<style scoped>
.wrapper {
  padding-left: 20%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 80%;
  padding-top: 50%;
  height: 100%;
}
.glow {
  color: #fff;
  text-align: center;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
      0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
  }

  to {
    text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a,
      0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
  }
}
.spin {
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  height: 100%;
  /*background: rgb(255,204,92,1);
    background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
  background: linear-gradient(rgb(0, 0, 0), rgb(0, 0, 0));
  border-right: 2px solid #cbcbcb;
  background-size: 100% auto;
  background-position: center top;
  background-attachment: fixed;
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}
</style>
